<template>
  <b-form-group
    label="İlgili Kişi"
    label-for="name"
  >
    <validation-provider
      #default="{ errors }"
      name="İlgili Kişi"
      rules="required"
    >
      <b-form-input
        id="name"
        v-model="dataItem.name"
        placeholder="İlgili Kişi"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'Name',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['customerAddresses/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
